module.exports = __webpack_public_path__ + "static-appopensalud/img/primesalud_blue_powered.7bb8d8b.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/primesalud_blue_powered.png
// module id = 1099
// module chunks = 120